<template>
  <div class="logo-header">
    <small class="header">{{ header }}</small>
    <img :src="logoAsset" alt="">
  </div>
</template>

<script>
export default {
  name: 'LogoHeader',
  props: {
    logoAsset: String,
    header: {
      type: String,
      default: 'Our partner'
    }
  }

}
</script>

<style lang="scss">
@import "LogoHeader.scss";
</style>
